import { MapLocation } from '@/types/location';

export const jizanDigitalMegacomScreens: MapLocation[] = [
  {
    id: 10044,
    name: "Digital Megacom Screen – Jizan",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.881889, 42.587222], // Converted from 16°52'58.8"N 42°35'14.0"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/b9824140-1c3e-4a22-a962-f1d829017055.png"
    }
  },
  {
    id: 10045,
    name: "Digital Megacom Screen – Jizan 2",
    type: "Digital Megacom",
    devices: 2,
    coordinates: [16.908519444, 42.549583333], // Converted from 16°54'30.7"N 42°32'58.5"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 2 faces\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/4681dbb8-87fa-4ab4-a78f-f88d0b901e18.png"
    }
  },
  {
    id: 10046,
    name: "Digital Megacom Screen – Jizan 3",
    type: "Digital Megacom",
    devices: 2,
    coordinates: [16.908025, 42.548305556], // Converted from 16°54'29.1"N 42°32'53.9"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 2 faces\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/eae18f1e-a34f-482c-a5c9-59dc289a04e7.png"
    }
  },
  {
    id: 10047,
    name: "Digital Megacom Screen – Jizan 4",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.929777778, 42.565], // Converted from 16°55'47.2"N 42°33'54.0"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/2ca36490-9c05-459a-81a2-20a064501917.png"
    }
  },
  {
    id: 10048,
    name: "Digital Megacom Screen – Jizan 5",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.924566667, 42.546916667], // Converted from 16°55'28.4"N 42°32'49.3"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/b63f2f44-4990-48f9-a5d7-fb83366af65b.png"
    }
  },
  {
    id: 10049,
    name: "Digital Megacom Screen – Jizan 6",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.904472222, 42.553111111], // Converted from 16°54'16.1"N 42°33'11.2"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/7a2728cc-5f84-46c4-b1b2-02cfdf4af7c2.png"
    }
  },
  {
    id: 10050,
    name: "Digital Megacom Screen – Jizan 7",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.927305556, 42.589138889], // Converted from 16°55'38.3"N 42°35'20.9"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/1f25c2bc-66a2-4255-b68e-af8a994031fc.png"
    }
  },
  {
    id: 10051,
    name: "Digital Megacom Screen – Jizan 8",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.839, 42.612], // Converted from 16°50'20.4"N 42°36'43.2"E (corrected invalid coordinates)
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/4716d0e9-66f4-40c7-aa06-b8e103a5adc3.png"
    }
  },
  {
    id: 10052,
    name: "Digital Megacom Screen – Jizan 9",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.897389, 42.550250], // Converted from 16°53'50.6"N 42°33'00.9"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/3995cf28-d521-4299-b9b5-c14cc13aa12d.png"
    }
  },
  {
    id: 10053,
    name: "Digital Megacom Screen – Jizan 10",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.892, 42.557139], // Converted from 16°53'31.2"N 42°33'25.7"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/ac1a8805-6055-4cf0-a0cc-93cac6d23428.png"
    }
  },
  {
    id: 10054,
    name: "Digital Megacom Screen – Jizan 11",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.911778, 42.550778], // Converted from 16°54'42.4"N 42°33'02.8"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/ebbecfcc-47e1-4244-bf2f-8c4e9fc307fd.png"
    }
  },
  {
    id: 10055,
    name: "Digital Megacom Screen – Jizan 12",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.8909167, 42.5579722], // Converted from 16°53'27.3"N 42°33'27.5"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/6b227188-8076-4da1-960b-ebbb0554c783.png"
    }
  },
  {
    id: 10056,
    name: "Digital Megacom Screen – Jizan 13",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.879139, 42.572389], // Converted from 16°52'44.9"N 42°34'20.6"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/9d1df71f-65b3-4294-807d-49fee79b07c4.png"
    }
  },
  {
    id: 10057,
    name: "Digital Megacom Screen – Jizan 14",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.930361, 42.612389], // Converted from 16°55'49.0"N 42°36'44.6"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/cd56acc3-1c69-4e6d-915b-34b97fdc450c.png"
    }
  },
  {
    id: 10058,
    name: "Digital Megacom Screen – Jizan 15",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.877808333, 42.628925], // Converted from 16°52'41.7"N 42°37'44.3"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/4a337e22-367a-4cd4-b162-1b2aa8e6867c.png"
    }
  },
  {
    id: 10059,
    name: "Digital Megacom Screen – Jizan 16",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.877855556, 42.562408333], // Converted from 16°52'41.7"N 42°33'44.7"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/e0aacc19-2c5b-4d0f-8ec2-ca5119c9762a.png"
    }
  },
  {
    id: 10060,
    name: "Digital Megacom Screen – Jizan 17",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.908333, 42.544250], // Converted from 16°54'30.0"N 42°32'39.3"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/2a8d15df-04c5-46b9-b5b1-1415ba8d90b1.png"
    }
  },
  {
    id: 10061,
    name: "Digital Megacom Screen – Jizan 18",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.901444, 42.548778], // Converted from 16°54'05.2"N 42°32'55.6"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/d54b73e8-9cc2-4a4e-bbe6-4b848cbad1e0.png"
    }
  },
  {
    id: 10062,
    name: "Digital Megacom Screen – Jizan 19",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.880472, 42.541861], // Converted from 16°52'49.7"N 42°32'30.7"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/5b474c43-7d6b-4f28-ae3f-f9fa3eb9212b.png"
    }
  },
  {
    id: 10063,
    name: "Digital Megacom Screen – Jizan 20",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [16.930750, 42.612083], // Converted from 16°55'50.7"N 42°36'43.5"E
    region: "Jizan",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/7f564ff7-3a06-4748-8d49-4bcc40cb4722.png"
    }
  }
];
